export var IconPosition;
(function (IconPosition) {
    IconPosition["LEFT"] = "LEFT";
    IconPosition["RIGHT"] = "RIGHT";
})(IconPosition || (IconPosition = {}));
